import { useMutation } from "@tanstack/react-query";
import { validateGroupId } from "@/services/group";
import { QueryKeys } from "@/constants";

const useGroup = () => {
  return useMutation({
    mutationKey: [QueryKeys.GROUP],
    mutationFn: (loginGroupId: string) => {
      return validateGroupId(loginGroupId);
    },
    retry: false,
  });
};
export default useGroup;
